import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var selectMobileDevice = mutatorAction('selectMobileDevice', function (index) {
    var store = mobileDeviceFullStore();
    store.selected = index;
});
//# sourceMappingURL=selectMobileDevice.js.map